import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import api from '../../../Services/api';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';

const LcrReport = () => {
  // State to store fetched data
  const [data, setData] = useState([]);
  const [masterData, setMasterData] = useState([]);
   const [loading, setLoading] = useState(true);
       const [snackbarOpen, setSnackbarOpen] = useState(false);
       const [snackbarMessage, setSnackbarMessage] = useState('');
       const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
        const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
  // Define the headers for the Excel sheet
  const headers = [
    'Sl No',
    'Vendor Code',
    'Name of Contractor/Sub-Contractor',
    'Address',
    'Contact Person',
    'Contact No',
    'Escalation Contact No',
    'Email Id',
    'Escalation Email Id',
    'Nature of Work',
    'Date of Commencement',
    'Date of Completion',
    'CLRA License No',
    'No. of Workers',
    'Valid Date',
    'BOCW RC No',
    'No. of Workers',
    'Valid Date',
    'WC Policy Number',
    'No. of Workers Covered',
    'Valid Date',
    'ESI Number',
    'PF Number',
    'PO Copy Number',
    'Valid Date',
    'HR Policy Undertaking Ack',
    'PSARA Licence',
    'Valid Date',
    'Factory Licence',
    'Valid Date',
    'GST Certificate'
  ];
 
  let data1 = sessionStorage.getItem('user');
  let clientData = JSON.parse(data1);
 
  let id;
  
  if (clientData && clientData.type === 'client') {
      id = clientData.id; 
  } else if (clientData && clientData.type === 'corporate') {
    let selectedClientId = sessionStorage.getItem('selectedClientId');
    console.log(selectedClientId,"idddd")
    
    if (selectedClientId) {
        id = selectedClientId;
    } else {
        console.error("Selected Client ID not found in sessionStorage.");
    }
  } else {
      console.error("Invalid user type or missing data.");
  }
  

  useEffect(() => {
    
    const fetchData = async () => {
      try {
        const response = await api.client.getLcrReport(id);
        if(response.status === 200) {
        const result = response.data;
        if (Array.isArray(result.data.vendorProfile) ) {
          setData(result.data.vendorProfile);
          setMasterData(result.data.vendorMasterData)
        } 
        setLoading(false)
        }
 else if(response.status === 400){
  setErrorSnackbarOpen(true);
  setSnackbarErrorMessage(response.data.message)
  setData([]);
  setLoading(false)
 }
 else if(response.status === 404){
  setErrorSnackbarOpen(true);
  setSnackbarErrorMessage(response.data.message)
  setData([]);
  setLoading(false)
 }
 else if(response.status === 500){
  setErrorSnackbarOpen(true);
  setSnackbarErrorMessage(response.data.message)
  setData([]);
  setLoading(false)
 }
      } catch (error) {
        console.error('Error fetching data:', error);
        setData([]);
      }
    };
 
    fetchData();
  }, [id]);
 
  // Function to generate Excel file
  const handleExport = () => {
    // Mapping API data to Excel sheet format
    const mappedData = data.map((item, index) => {
      const masterItem = masterData.find((master) => master.vendorId === item.vendorId);
 
   return{
      'Sl No': index + 1,  // Automatically generate Sl No starting from 1
      'Vendor Code' : item?.vendorCode ? item?.vendorCode : 'N/A',
      'Name of Contractor/Sub-Contractor': item?.vendorCompanyName || 'N/A',
      'Address': (item?.vendorCompanyAddress ? item.vendorCompanyAddress + ', ' : '') + (item?.vendorPlaceName ? item.vendorPlaceName + ', ' : '') + (item?.vendorStateId ? item.vendorStateId + '-': '') + (item?.vendorPinCode || 'N/A'),
      'Contact Person': item?.vendorName || 'N/A',
      'Contact No': item?.vendorPhoneNumber || 'N/A',
      'Escalation Contact No': item?.vendorPhoneNumber1 || 'N/A',
      'Email Id': item?.vendorEmail || 'N/A',
      'Escalation Email Id': item?.vendorEmail1 || 'N/A',
      'Nature of Work': item?.natureOfWork || 'N/A',

      // Check for nested values in masterItem and handle with fallbacks
      'Date of Commencement': masterItem?.dateOfCommencement?.value?.slice(0, 10) || 'N/A',
      'Date of Exit': masterItem?.dateOfCompletion?.value?.slice(0, 10) || 'N/A',

      'CLRA License No': masterItem?.clraLicence?.value || 'N/A',
      'No. of Workers (CLRA)': masterItem?.clraLicence?.noOfWorkers || 'N/A',
      'Valid Date (CLRA)': masterItem?.clraLicence?.validDate || 'N/A',

      'BOCW RC No': masterItem?.bocwRc?.value || 'N/A',
      'No. of Workers (BOCW)': masterItem?.bocwRc?.noOfWorkers || 'N/A',
      'Valid Date (BOCW)': masterItem?.bocwRc?.validDate || 'N/A',

      'WC Policy Number': masterItem?.wCPolicyNumber?.value || 'N/A',
      'No. of Workers Covered (WC)': masterItem?.wCPolicyNumber?.noOfWorkers || 'N/A',
      'Valid Date (WC)': masterItem?.wCPolicyNumber?.validDate || 'N/A',

      'ESI Number': masterItem?.esicAllotment?.value || 'N/A',
      'PF Number': masterItem?.epfoAllotment?.value || 'N/A',

      'PO Copy Number': masterItem?.poCopy?.value || 'N/A',
      'Valid Date (PO Copy)': masterItem?.poCopy?.validDate || 'N/A',

      'HR Policy Undertaking Ack': masterItem?.hrPolicyUndertakingAck?.validation === 2 ? 'Submitted' : 'Not Submitted',
      
      'PSARA Licence': masterItem?.passaraLicence?.value || 'N/A',
      'Valid Date (PSARA)': masterItem?.passaraLicence?.validDate || 'N/A',

      'Factory Licence': masterItem?.factoryLicence?.value || 'N/A',
      'Valid Date (Factory Licence)': masterItem?.factoryLicence?.validDate || 'N/A',

      'GSTCertificate' : masterItem?.GSTCertificate?.value || 'N/A',
 
   };
 
    });
 
    // const
 
    // Create worksheet from the data
    const ws = XLSX.utils.json_to_sheet(mappedData);
 
    // Add headers manually to the worksheet
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: 'A1' });
 
 
    // Style the worksheet (optional)
    const wsCols = [
      { wpx: 50  }, // Sl No
      { WPX: 50  }, //vendor code
      { wpx: 250 }, // Name of Contractor/Sub-Contractor
      { wpx: 300 }, // Address
      { wpx: 200 }, // Contact Person
      { wpx: 100 }, // Contact No
      { wpx: 100 }, // Escalation Contact No
      { wpx: 250 }, // Email Id
      { wpx: 250 }, // Escalation Email Id
      { wpx: 150 }, // Nature of Work
      { wpx: 100 }, // Date of Commencement
      { wpx: 100 }, // Date of Exit
      { wpx: 100 }, // CLRA License No
      { wpx: 100 }, // No. of Workers
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // BOCW RC No
      { wpx: 100 }, // No. of Workers
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // WC Policy Number
      { wpx: 100 }, // No. of Workers Covered
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // ESI Number
      { wpx: 100 }, // PF Number
      { wpx: 100 }, // PO Copy Number
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // HR Policy Undertaking Ack
      { wpx: 100 }, // PSARA Licence
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Factory Licence
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, //GST Certificate
 
    ];
 
    ws['!cols'] = wsCols; // Apply column widths
 
    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Contractor Report');
 
    // Write the workbook to a file
    XLSX.writeFile(wb, 'Vendor Details.xlsx');
  };
 
  return (
    <div>
      <Snackbar
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                severity="success"
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                 sx={{
                  marginTop: '2.9%', 
                  marginRight: '7%'
                }}
              >
                <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
              </Snackbar>
              <Snackbar
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                severity="success"
                open={errorSnackbarOpen}
                autoHideDuration={3000}
                onClose={() => {setErrorSnackbarOpen(false)}}
                sx={{
                  marginTop: '2.9%', 
                  marginRight: '7%'
                }}
              >
                <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
              </Snackbar>
      <button className="btn btn-sm btn-danger mb-2" onClick={handleExport}>Download Excel</button>
      {/* Optionally display the fetched data in a table */}
      <div style={{ minHeight: "380px", maxHeight: "400px", marginTop:"10px", overflowY: "auto" }}>
        <table style={{  width: '100%' }}>
          <thead className="position-sticky top-0 " style={{zIndex:1000, backgroundColor: 'black', color: 'white', fontWeight: 'bold' }}>
            <tr>
              {headers.map((header, index) => (
                <th key={index} style={{ border: '1px solid white', padding: '8px' }}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {/* {loading ? (
               <div>
               <h4 className="text-center mt-5">Loading......</h4>
           </div>
            ) :  */}
             {data && data.length > 0 ? (
              data.map((item, index) => {
                const masterItem = masterData.find((master) => master.vendorId === item.vendorId);
                console.log("masteritem", masterItem);
                
                return (
                <tr key={index}>
                  <td  >{index + 1}</td>
                  <td  >{ item?.vendorCode || 'N/A'}</td>
                  <td  >{item.vendorCompanyName}</td>
                  <td  >{item.vendorCompanyAddress}, {item.vendorPlaceName}, {item.vendorStateId}-{item.vendorPinCode}</td>
                  <td  >{item.vendorName}</td>
                  <td  >{item.vendorPhoneNumber}</td>
                  <td  >{item.vendorPhoneNumber1 ? item.vendorPhoneNumber1 : 'NA'}</td>
                  <td  >{item.vendorEmail}</td>
                  <td  >{item.vendorEmail1 ? item.vendorEmail1 : 'NA'}</td>
                  <td  >{item.natureOfWork}</td>

                  {/* <td  >{masterItem ? masterItem?.dateOfCommencement?.value.slice(0,10) : 'N/A'}</td> */}
                  {/* <td  >{masterItem ? masterItem?.dateOfCompletion?.value.slice(0,10) : 'N/A'}</td> */}

                  <td >{ masterItem?.dateOfCommencement?.validation === 2 && masterItem?.dateOfCommencement?.na === true ? 'NA' : masterItem?.dateOfCommencement?.validation === 3 && masterItem?.dateOfCommencement?.value ? 'NA' : masterItem?.dateOfCommencement?.value || 'NA' }</td>
                  <td >{ masterItem?.dateOfCompletion?.validation === 2 && masterItem?.dateOfCompletion?.na === true ? 'NA' : masterItem?.dateOfCompletion?.validation === 3 && masterItem?.dateOfCompletion?.value ? 'NA' : masterItem?.dateOfCompletion?.value || 'NA' }</td>


                  {/* <td  >{masterItem ? masterItem.clraLicence.value : 'NA'}</td> */}
                  <td >{ masterItem?.clraLicence?.validation === 2 && masterItem?.clraLicence?.na === true ? 'NA' : masterItem?.clraLicence?.validation === 3 && masterItem?.clraLicence?.value ? 'NA' : masterItem?.clraLicence?.value || 'NA' }</td>
                  <td  >{ masterItem?.clraLicence?.validation === 2 && masterItem?.clraLicence?.na === true ? 'NA' : masterItem?.clraLicence?.validation === 3 &&  masterItem?.clraLicence?.noOfWorkers ? 'NA' : masterItem?.clraLicence?.noOfWorkers || 'NA'  }</td>
                  <td  >{ masterItem?.clraLicence?.validation === 2 && masterItem?.clraLicence?.na === true ? 'NA' : masterItem?.clraLicence?.validation === 3 &&  masterItem?.clraLicence?.validDate ? 'NA' : masterItem?.clraLicence?.validDate || 'NA'}</td>

                  <td >{ masterItem?.bocwRc?.validation === 2 && masterItem?.bocwRc?.na === true ? 'NA' : masterItem?.bocwRc?.validation === 3 &&  masterItem?.bocwRc?.value ? 'NA' : masterItem?.bocwRc?.value || 'NA' }</td>
                  <td  >{ masterItem?.bocwRc?.validation === 2 && masterItem?.bocwRc?.na === true ? 'NA' : masterItem?.bocwRc.validation === 3 &&  masterItem?.bocwRc?.noOfWorkers ? 'NA' : masterItem?.bocwRc?.noOfWorkers || 'NA'}</td>
                  <td  >{ masterItem?.bocwRc?.validation === 2 && masterItem?.bocwRc?.na === true ? 'NA' : masterItem?.bocwRc.validation === 3 &&  masterItem?.bocwRc?.validDate ? 'NA' : masterItem?.bocwRc?.validDate || 'NA'}</td>


                  <td >{ masterItem?.wCPolicyNumber?.validation === 2 && masterItem?.wCPolicyNumber?.na === true ? 'NA' : masterItem?.wCPolicyNumber?.validation === 3 &&  masterItem?.wCPolicyNumber?.value ? 'NA' : masterItem?.wCPolicyNumber?.value || 'NA'}</td>
                  <td  >{ masterItem?.wCPolicyNumber?.validation === 2 && masterItem?.wCPolicyNumber?.na === true ? 'NA' : masterItem?.wCPolicyNumber?.validation === 3 &&  masterItem?.wCPolicyNumber?.noOfWorkers ? 'NA' : masterItem?.wCPolicyNumber?.noOfWorkers|| 'NA' }</td>
                  <td  >{ masterItem?.wCPolicyNumber?.validation === 2 && masterItem?.wCPolicyNumber?.na === true ? 'NA' : masterItem?.wCPolicyNumber?.validation === 3 &&  masterItem?.wCPolicyNumber?.validDate ? 'NA' : masterItem?.wCPolicyNumber?.validDate || 'NA'}</td>

                  <td >{ masterItem?.esicAllotment?.validation === 2 && masterItem?.esicAllotment?.na === true ? 'NA' : masterItem?.esicAllotment?.validation === 3 &&  masterItem?.esicAllotment?.value ? 'NA' : masterItem?.esicAllotment?.value || 'NA'}</td>

                  <td >{ masterItem?.epfoAllotment?.validation === 2 && masterItem?.epfoAllotment?.na === true ? 'NA' : masterItem?.epfoAllotment?.validation === 3 &&  masterItem?.epfoAllotment?.value ? 'NA' : masterItem?.epfoAllotment?.value || 'NA'}</td>

                  <td >{ masterItem?.poCopy?.validation === 2 && masterItem?.poCopy?.na === true ? 'NA' : masterItem?.poCopy?.validation === 3 &&  masterItem?.poCopy?.value ? 'NA' : masterItem?.poCopy?.value || 'NA'}</td>
                  <td  >{ masterItem?.poCopy?.validation === 2 && masterItem?.poCopy?.na === true ? 'NA' : masterItem?.poCopy?.validation === 3 &&  masterItem?.poCopy?.validDate ? 'NA' : masterItem?.poCopy?.validDate|| 'NA' }</td>
                  
                  <td  >{masterItem && masterItem?.hrPolicyUndertakingAck && masterItem?.hrPolicyUndertakingAck?.validation === 2 ? 'Submitted' : 'Not Submitted'}</td>

                  <td >{ masterItem?.passaraLicence?.validation === 2 && masterItem?.passaraLicence?.na === true ? 'NA' : masterItem?.passaraLicence?.validation === 3 &&  masterItem?.passaraLicence?.value ? 'NA' : masterItem?.passaraLicence?.value || 'NA' }</td>
                  <td  >{ masterItem?.passaraLicence?.validation === 2 && masterItem?.passaraLicence?.na === true ? 'NA' : masterItem?.passaraLicence?.validation === 3 &&  masterItem?.passaraLicence?.validDate ? 'NA' : masterItem?.passaraLicence?.validDate || 'NA'}</td>
                  
                  <td >{ masterItem?.factoryLicence?.validation === 2 && masterItem?.factoryLicence?.na === true ? 'NA' : masterItem?.factoryLicence?.validation === 3 &&  masterItem?.factoryLicence?.value ? 'NA' : masterItem?.factoryLicence?.value || 'NA'}</td>
                  <td  >{ masterItem?.factoryLicence?.validation === 2 && masterItem?.factoryLicence?.na === true ? 'NA' : masterItem?.factoryLicence?.validation === 3 &&  masterItem?.factoryLicence?.validDate ? 'NA' : masterItem?.factoryLicence?.validDate || 'NA'}</td>

                  <td >{ masterItem?.GSTCertificate?.validation === 2 && masterItem?.GSTCertificate?.na === true ? 'NA' : masterItem?.GSTCertificate?.validation === 3 &&  masterItem?.GSTCertificate?.value ? 'NA' : masterItem?.GSTCertificate?.value || 'NA'}</td>

                  
                </tr>
              )
  })
            ) : (
              <tr>
                <td colSpan={headers.length}>No Vendor found for this client</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
 
export default LcrReport;